exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pageTitle-container{width:300px;display:flex;flex-direction:row;flex-wrap:no-wrap;align-items:center;justify-content:space-between;margin:35px 0}.rectangle{width:35px;height:6px;background-color:\"transparent\"}.headerText{font-family:'Lato-Regular', sans-serif;font-size:30px;color:var(--title-text-color);width:100%;text-align:center}@media screen and (max-width: 960px){.pageTitle-container{margin:20px 0}}\n", ""]);

// exports
